import * as Components from '@swp/components'

export default Components
